import { atom } from "jotai";
import { CurrentUser } from "../../types/models";

export const userAtom = atom<CurrentUser | null>(null);

export const isAuthenticatedAtom = atom((get) => !!get(userAtom));

export const userRoleAtom = atom((get) => get(userAtom)?.role || null);

export const tokenAtom = atom<string | null>(localStorage.getItem("authToken"));

tokenAtom.onMount = (setAtom) => {
  const handleStorageChange = () => {
    setAtom(localStorage.getItem("authToken"));
  };

  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
};

export const setAuthAtom = atom(
  null,
  (get, set, { user, token }: { user: CurrentUser | null; token: string | null }) => {
    set(userAtom, user);
    set(tokenAtom, token);

    if (token) {
      localStorage.setItem("authToken", token); // Sync to localStorage
    } else {
      localStorage.removeItem("authToken");
    }
  }
);

export const clearAuthAtom = atom(null, (_get, set) => {
  set(userAtom, null);
  set(tokenAtom, null);
  localStorage.removeItem("authToken");
});
